export enum FlexDirection {
    Row = "row",
    Column = "column",
    ReverseRow = "reverse-row",
    ReverseColumn = "reverse-column",
}

export enum FlexBehaviour {
    Min = "min",
    Max = "max",
    Center = "center",
}

export enum Alignment {
    Left = "left",
    Center = "center",
    Right = "right",
}

export enum Position {
    Relative = "relative",
    Absolute = "absolute",
    Fixed = "fixed",
    Sticky = "sticky",
}

export enum Side {
    None = "none",
    Top = "top",
    Bottom = "bottom",
    Left = "left",
    Right = "right",
    Vertical = "vertical",
    Horizontal = "horizontal",
    All = "all",
}

export enum Size {
    XtraSmall = "xtrasmall",
    Small = "small",
    Medium = "medium",
    Large = "large",
    XtraLarge = "xtralarge",
}
